import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { Observable, of, observable, Subscriber, BehaviorSubject } from 'rxjs';
import { EmpresaContratante } from 'src/app/shared/models/dados-contratante';
import { TokenLogin } from 'src/app/shared/models/login-response';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class StepNavigatorService {

    private md: 'multi' | 'single' = undefined;

    private singletonObservable: Observable<'multi' | 'single'> = undefined;
    public refreshed$: BehaviorSubject<boolean> = new BehaviorSubject(true);;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private authService: AuthService) {

    }

    /**
     * Retorna single se a empresa já concluiu o processo cadastral, otherwise multi
     */
    mode(): Observable<'multi' | 'single'> {
        return new Observable<'multi' | 'single'>(obs => {

            // TODO: refatorar no authservice
            const tokenUsuario = this.authService.credentials;

            if (tokenUsuario) {

                const empresaContratante = tokenUsuario.contratante;
                const situacao = empresaContratante.situacaoProcessoCadastral;

                const processoCadastralOcorrendo = situacao !== 'Concluido';

                obs.next(processoCadastralOcorrendo ? 'multi' : 'single');
                return;
            }
            if (!this.router.url.includes('logon')) {
                this.router.navigateByUrl('logon');
            }
            obs.error();
            
        });
        // if (this.md) {
        //     return of(this.md);
        // }
        // if (this.singletonObservable) {
        //     return this.singletonObservable;
        // }
        // this.singletonObservable = this.apiService
        //     .obterDadosContratante()
        //     .pipe(map(
        //         (dado: EmpresaContratante) => {
        //             // Define se é multi ou não de acordo com o Banco
        //             (dado.situacaoProcessoCadastral === 'Concluido')
        //                 ? this.md = 'single'
        //                 : this.md = 'multi';


        //             return this.md;
        //         }
        //     )
        //     ) as Observable<'multi' | 'single'>;
        //return this.singletonObservable;
    }

    refresh() {
        return this.apiService
            .obterDadosContratante(true)
            .pipe(map(
                (dado: EmpresaContratante) => {
                    this.refreshed$.next(true);
                    // Define se é multi ou não de acordo com o Banco
                    (dado.situacaoProcessoCadastral === 'Concluido')
                        ? this.md = 'single'
                        : this.md = 'multi';


                    return this.md;
                }
            )
            );
    }

}
